import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/overlay.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../packages/props-utils/prop-types.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bemOverlay = new HoneyBem('overlay', styles);
function Overlay(_a) {
  var {
      extraClasses,
      innerRef
    } = _a,
    rest = __rest(_a, ["extraClasses", "innerRef"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: innerRef,
    className: bemOverlay.b(false, extraClasses)
  }, rest));
}
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  extraClasses: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.element, PropTypes.object])
  })])
};
var Overlay$1 = Injecss(Overlay, styles);

export { Overlay, Overlay$1 as default };
